/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddAiRealtimeKeywordPayload } from '../models/AddAiRealtimeKeywordPayload';
import type { AddCompetitorKeywordPayload } from '../models/AddCompetitorKeywordPayload';
import type { AiRealtimeKeywordFolderPayload } from '../models/AiRealtimeKeywordFolderPayload';
import type { BasicResponseAiInsightReport } from '../models/BasicResponseAiInsightReport';
import type { BasicResponseAiRealtimeKeywordItem } from '../models/BasicResponseAiRealtimeKeywordItem';
import type { BasicResponseAnalysisResultCollection } from '../models/BasicResponseAnalysisResultCollection';
import type { BasicResponseContentFilterItem } from '../models/BasicResponseContentFilterItem';
import type { BasicResponseContentLinkCollection } from '../models/BasicResponseContentLinkCollection';
import type { BasicResponseDailyIssueCount } from '../models/BasicResponseDailyIssueCount';
import type { BasicResponseEmotionalKeywordChartData } from '../models/BasicResponseEmotionalKeywordChartData';
import type { BasicResponseEmotionalKeywordContentByKeywordList } from '../models/BasicResponseEmotionalKeywordContentByKeywordList';
import type { BasicResponseEmotionalKeywordContentList } from '../models/BasicResponseEmotionalKeywordContentList';
import type { BasicResponseIssueCountChartData } from '../models/BasicResponseIssueCountChartData';
import type { BasicResponseKeywordFilterResponse } from '../models/BasicResponseKeywordFilterResponse';
import type { BasicResponseKeywordSearchVolumeChart } from '../models/BasicResponseKeywordSearchVolumeChart';
import type { BasicResponseKeywordTreeResponse } from '../models/BasicResponseKeywordTreeResponse';
import type { BasicResponseListAiRealtimeKeywordItem } from '../models/BasicResponseListAiRealtimeKeywordItem';
import type { BasicResponseListString } from '../models/BasicResponseListString';
import type { BasicResponseListUUID } from '../models/BasicResponseListUUID';
import type { BasicResponseReportContent } from '../models/BasicResponseReportContent';
import type { BasicResponseString } from '../models/BasicResponseString';
import type { BasicResponseTopEmotionalKeywordRank } from '../models/BasicResponseTopEmotionalKeywordRank';
import type { BasicResponseUUID } from '../models/BasicResponseUUID';
import type { BasicResponseVoid } from '../models/BasicResponseVoid';
import type { ContentFilterItem } from '../models/ContentFilterItem';
import type { KeywordFilterSaveRequest } from '../models/KeywordFilterSaveRequest';
import type { ModifyAiRealtimeKeywordPayload } from '../models/ModifyAiRealtimeKeywordPayload';
import type { ModifyCompetitorKeywordPayload } from '../models/ModifyCompetitorKeywordPayload';
import type { ModifyKeywordContextPayload } from '../models/ModifyKeywordContextPayload';
import type { MoveKeywordToFolderPayload } from '../models/MoveKeywordToFolderPayload';
import type { SetFolderCollapsedPayload } from '../models/SetFolderCollapsedPayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TeambinderAiApiService {

    /**
     * AI 실시간 감지 키워드 조회
     * @returns BasicResponseAiRealtimeKeywordItem OK
     * @throws ApiError
     */
    public static getAiRealtimeKeyword({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseAiRealtimeKeywordItem> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 수정
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static modifyAiRealtimeKeyword({
        keywordId,
        requestBody,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        requestBody: ModifyAiRealtimeKeywordPayload,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}',
            path: {
                'keyword-id': keywordId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 삭제
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static deleteAiRealtimeKeyword({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * 키워드 정의 조회
     * @returns BasicResponseString OK
     * @throws ApiError
     */
    public static getKeywordContext({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseString> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/keyword-context',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * 키워드 정의 수정
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static modifyKeywordContext1({
        keywordId,
        requestBody,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        requestBody: ModifyKeywordContextPayload,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/keyword-context',
            path: {
                'keyword-id': keywordId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 폴더 이동 (영역 + 영역 내 위치 동시 변경)
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static moveKeywordToFolder({
        keywordId,
        requestBody,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        requestBody: MoveKeywordToFolderPayload,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/folder',
            path: {
                'keyword-id': keywordId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 필터 설정 조회
     * @returns BasicResponseKeywordFilterResponse OK
     * @throws ApiError
     */
    public static getFilter({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseKeywordFilterResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/filter',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 필터 설정 저장
     * @returns BasicResponseKeywordFilterResponse OK
     * @throws ApiError
     */
    public static saveFilter({
        keywordId,
        requestBody,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        requestBody: KeywordFilterSaveRequest,
    }): CancelablePromise<BasicResponseKeywordFilterResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/filter',
            path: {
                'keyword-id': keywordId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * 키워드의 컨텐츠 필터 설정 조회
     * @returns BasicResponseContentFilterItem OK
     * @throws ApiError
     */
    public static getContentFilter({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseContentFilterItem> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/content-filter',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * 키워드의 컨텐츠 필터 설정 업데이트
     * @returns BasicResponseContentFilterItem OK
     * @throws ApiError
     */
    public static updateContentFilter({
        keywordId,
        requestBody,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        requestBody: ContentFilterItem,
    }): CancelablePromise<BasicResponseContentFilterItem> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/content-filter',
            path: {
                'keyword-id': keywordId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 순서 조정
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static changeOrder({
        target,
        prev,
    }: {
        target: string,
        prev?: string,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keywords/orders',
            query: {
                'target': target,
                'prev': prev,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 폴더 이름 수정
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static renameFolder({
        folderId,
        requestBody,
    }: {
        /**
         * 폴더 ID
         */
        folderId: string,
        requestBody: AiRealtimeKeywordFolderPayload,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keyword-folders/{folder-id}',
            path: {
                'folder-id': folderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 폴더 삭제 (안의 키워드는 미분류로 이동)
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static deleteFolder({
        folderId,
    }: {
        /**
         * 폴더 ID
         */
        folderId: string,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/binder-app/ai-realtime/keyword-folders/{folder-id}',
            path: {
                'folder-id': folderId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 폴더 순서 조정
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static changeFolderOrder({
        target,
        prev,
    }: {
        target: string,
        prev?: string,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/keyword-folders/orders',
            query: {
                'target': target,
                'prev': prev,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 - 경쟁사 키워드 수정
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static modifyCompetitorKeyword({
        competitorId,
        requestBody,
    }: {
        /**
         * 경쟁사 ID
         */
        competitorId: string,
        requestBody: ModifyCompetitorKeywordPayload,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/binder-app/ai-realtime/competitors/{competitor-id}',
            path: {
                'competitor-id': competitorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 - 경쟁사 키워드 삭제
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static deleteCompetitorKeyword({
        competitorId,
    }: {
        /**
         * 경쟁사 ID
         */
        competitorId: string,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/binder-app/ai-realtime/competitors/{competitor-id}',
            path: {
                'competitor-id': competitorId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 리스트 조회
     * @returns BasicResponseListAiRealtimeKeywordItem OK
     * @throws ApiError
     */
    public static getAllAiRealtimeKeyword(): CancelablePromise<BasicResponseListAiRealtimeKeywordItem> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keywords',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 등록
     * @returns BasicResponseUUID OK
     * @throws ApiError
     */
    public static addAiRealtimeKeyword({
        requestBody,
    }: {
        requestBody: AddAiRealtimeKeywordPayload,
    }): CancelablePromise<BasicResponseUUID> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/binder-app/ai-realtime/keywords',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 - 경쟁사 키워드 등록
     * @returns BasicResponseUUID OK
     * @throws ApiError
     */
    public static addCompetitorKeyword({
        keywordId,
        requestBody,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        requestBody: AddCompetitorKeywordPayload,
    }): CancelablePromise<BasicResponseUUID> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/binder-app/ai-realtime/keywords/{keyword-id}/competitors',
            path: {
                'keyword-id': keywordId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 폴더 생성
     * @returns BasicResponseUUID OK
     * @throws ApiError
     */
    public static createFolder({
        requestBody,
    }: {
        requestBody: AiRealtimeKeywordFolderPayload,
    }): CancelablePromise<BasicResponseUUID> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/binder-app/ai-realtime/keyword-folders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 폴더 접힘 상태 변경
     * @returns BasicResponseVoid OK
     * @throws ApiError
     */
    public static setCollapsed({
        folderId,
        requestBody,
    }: {
        /**
         * 폴더 ID
         */
        folderId: string,
        requestBody: SetFolderCollapsedPayload,
    }): CancelablePromise<BasicResponseVoid> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/binder-app/ai-realtime/keyword-folders/{folder-id}/collapsed',
            path: {
                'folder-id': folderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 긍정부정 지표
     * @returns BasicResponseTopEmotionalKeywordRank OK
     * @throws ApiError
     */
    public static getTopEmotionalKeywords({
        keywordId,
        timeUnit,
        startDate,
        endDate,
    }: {
        keywordId: string,
        timeUnit: 'THIS_WEEK' | 'THIS_MONTH' | 'THIS_YEAR' | 'RECENT_WEEK' | 'RECENT_MONTH' | 'RECENT_YEAR',
        /**
         * 조회 시작일 (yyyy-MM-dd). 종료일과 함께 입력 시 timeUnit보다 우선 적용
         */
        startDate?: string,
        /**
         * 조회 종료일 (yyyy-MM-dd). 시작일과 함께 입력 시 timeUnit보다 우선 적용
         */
        endDate?: string,
    }): CancelablePromise<BasicResponseTopEmotionalKeywordRank> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/top-emotional-keywords',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'timeUnit': timeUnit,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 특정 감성 키워드 원본 컨텐츠 조회
     * @returns BasicResponseEmotionalKeywordContentByKeywordList OK
     * @throws ApiError
     */
    public static getEmotionalKeywordContentByKeyword({
        keywordId,
        timeUnit,
        emotionalType,
        emotionalKeyword,
        start,
        display,
    }: {
        keywordId: string,
        /**
         * 기간 단위 (THIS_WEEK, THIS_MONTH, THIS_YEAR, RECENT_WEEK, RECENT_MONTH, RECENT_YEAR)
         */
        timeUnit: 'THIS_WEEK' | 'THIS_MONTH' | 'THIS_YEAR' | 'RECENT_WEEK' | 'RECENT_MONTH' | 'RECENT_YEAR',
        /**
         * 감성 타입 (POSITIVE, NEGATIVE)
         */
        emotionalType: 'POSITIVE' | 'NEGATIVE',
        /**
         * 감성 키워드
         */
        emotionalKeyword?: string,
        /**
         * 페이지 번호 (1부터 시작)
         */
        start?: number,
        /**
         * 페이지 사이즈
         */
        display?: number,
    }): CancelablePromise<BasicResponseEmotionalKeywordContentByKeywordList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/top-emotional-keywords/source-contents',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'timeUnit': timeUnit,
                'emotionalType': emotionalType,
                'emotionalKeyword': emotionalKeyword,
                'start': start,
                'display': display,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 키워드 검색량 조회
     * @returns BasicResponseKeywordSearchVolumeChart OK
     * @throws ApiError
     */
    public static getEmotionalKeywordChartData({
        keywordId,
        timeUnit,
    }: {
        keywordId: string,
        timeUnit?: 'THIS_WEEK' | 'THIS_MONTH' | 'THIS_YEAR' | 'RECENT_WEEK' | 'RECENT_MONTH' | 'RECENT_YEAR',
    }): CancelablePromise<BasicResponseKeywordSearchVolumeChart> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/search-volume-chart',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'timeUnit': timeUnit,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 플랫폼별 기간 내 이슈 카운트 차트
     * @returns BasicResponseIssueCountChartData OK
     * @throws ApiError
     */
    public static getIssueCountChartData({
        keywordId,
        timeUnit,
        startDate,
        endDate,
    }: {
        keywordId: string,
        timeUnit: 'THIS_WEEK' | 'THIS_MONTH' | 'THIS_YEAR' | 'RECENT_WEEK' | 'RECENT_MONTH' | 'RECENT_YEAR',
        /**
         * 조회 시작일 (yyyy-MM-dd). 종료일과 함께 입력 시 timeUnit보다 우선 적용
         */
        startDate?: string,
        /**
         * 조회 종료일 (yyyy-MM-dd). 시작일과 함께 입력 시 timeUnit보다 우선 적용
         */
        endDate?: string,
    }): CancelablePromise<BasicResponseIssueCountChartData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/issue-count-chart',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'timeUnit': timeUnit,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 긍정부정 변화량 그래프 데이터 조회
     * @returns BasicResponseEmotionalKeywordChartData OK
     * @throws ApiError
     */
    public static getEmotionalKeywordChartData1({
        keywordId,
        timeUnit,
        startDate,
        endDate,
    }: {
        keywordId: string,
        timeUnit: 'THIS_WEEK' | 'THIS_MONTH' | 'THIS_YEAR' | 'RECENT_WEEK' | 'RECENT_MONTH' | 'RECENT_YEAR',
        /**
         * 조회 시작일 (yyyy-MM-dd). 종료일과 함께 입력 시 timeUnit보다 우선 적용
         */
        startDate?: string,
        /**
         * 조회 종료일 (yyyy-MM-dd). 시작일과 함께 입력 시 timeUnit보다 우선 적용
         */
        endDate?: string,
    }): CancelablePromise<BasicResponseEmotionalKeywordChartData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/emotional-keyword-metrics',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'timeUnit': timeUnit,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 긍정부정 키워드 원본 컨텐츠 조회
     * @returns BasicResponseEmotionalKeywordContentList OK
     * @throws ApiError
     */
    public static getEmotionalKeywordContent({
        keywordId,
        date,
    }: {
        keywordId: string,
        date: string,
    }): CancelablePromise<BasicResponseEmotionalKeywordContentList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/emotional-keyword-metrics/source-contents',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'date': date,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 종합리포트, 데일리 이슈 카운트 조회
     * @returns BasicResponseDailyIssueCount OK
     * @throws ApiError
     */
    public static getDailyIssueCount({
        keywordId,
    }: {
        keywordId: string,
    }): CancelablePromise<BasicResponseDailyIssueCount> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-summary/report/{keyword-id}/daily-issue-count',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 대시보드 (카운트, 그래프) 조회
     * @returns BasicResponseReportContent OK
     * @throws ApiError
     */
    public static getAiRealtimeContentReport({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseReportContent> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/report/{keyword-id}',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 리포트 24시간 이내 컨텐츠 리스트 조회
     * @returns BasicResponseAnalysisResultCollection OK
     * @throws ApiError
     */
    public static getAiRealtimeContentsWithin24Hours({
        keywordId,
        display,
        start,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        /**
         * 페이지 사이즈 (1 ~ 100 사이의 값)
         */
        display?: number,
        /**
         * 페이지 번호 (1부터 시작)
         */
        start?: number,
    }): CancelablePromise<BasicResponseAnalysisResultCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/report/{keyword-id}/contents/24h',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'display': display,
                'start': start,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 리포트 24시간 이내 감정별 컨텐츠 리스트 조회
     * @returns BasicResponseAnalysisResultCollection OK
     * @throws ApiError
     */
    public static getAiRealtimeContentsBySentimentWithin24Hours({
        keywordId,
        sentimentType,
        display,
        start,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        /**
         * 감정 타입 (POSITIVE 또는 NEGATIVE)
         */
        sentimentType: 'POSITIVE' | 'NEGATIVE',
        /**
         * 페이지 사이즈 (1 ~ 100 사이의 값)
         */
        display?: number,
        /**
         * 페이지 번호 (1부터 시작)
         */
        start?: number,
    }): CancelablePromise<BasicResponseAnalysisResultCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/report/{keyword-id}/contents/24h/sentiment',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'display': display,
                'start': start,
                'sentimentType': sentimentType,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 리포트 컨텐츠 리스트 조회 (v2 - 전체 개수 포함)
     * @returns BasicResponseAnalysisResultCollection OK
     * @throws ApiError
     */
    public static getAiRealtimeContentsV2({
        keywordId,
        display,
        start,
        showAd,
        enabledPlatforms,
        sortType,
        relevance,
        cursor,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        /**
         * 페이지 사이즈 (1 ~ 100 사이의 값)
         */
        display?: number,
        /**
         * 페이지 번호 (1부터 시작)
         */
        start?: number,
        /**
         * 광고 표시 여부
         */
        showAd?: boolean,
        /**
         * 활성화된 플랫폼 목록
         */
        enabledPlatforms?: Array<'NAVER_NEWS' | 'NAVER_BLOG' | 'NAVER_CAFE' | 'YOUTUBE' | 'INSTAGRAM' | 'TWITTER' | 'DCINSIDE' | 'BOBAEDREAM' | 'THEQOO' | 'PPOMPPU'>,
        /**
         * 정렬 방식
         */
        sortType?: 'LATEST' | 'RELEVANCE',
        /**
         * 최소 관련도 점수 (0~100, 10단위 권장. 이 값 이상인 콘텐츠만 조회하며, 10단위로 내림 처리됨)
         */
        relevance?: number,
        /**
         * 다음 페이지 커서 (nextCursor 값 사용, 향후 Keyset 페이지네이션용)
         */
        cursor?: string,
    }): CancelablePromise<BasicResponseAnalysisResultCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/report/v2/{keyword-id}/contents',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'display': display,
                'start': start,
                'showAd': showAd,
                'enabledPlatforms': enabledPlatforms,
                'sortType': sortType,
                'relevance': relevance,
                'cursor': cursor,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 - 경쟁사 키워드 조회
     * @returns BasicResponseListUUID OK
     * @throws ApiError
     */
    public static findCompetitor({
        keywordId,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
    }): CancelablePromise<BasicResponseListUUID> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keyword/{keyword-id}/competitors',
            path: {
                'keyword-id': keywordId,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 실시간 감지 키워드 트리 조회 (폴더 UI 전용)
     * @returns BasicResponseKeywordTreeResponse OK
     * @throws ApiError
     */
    public static getAiRealtimeKeywordTree(): CancelablePromise<BasicResponseKeywordTreeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-realtime/keyword-tree',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 인사이트 리포트 발행된 날짜 리스트 조회
     * @returns BasicResponseListString OK
     * @throws ApiError
     */
    public static getReportAvailableDates({
        keywordId,
        month,
    }: {
        /**
         * 키워드 ID
         */
        keywordId: string,
        /**
         * 년-월
         */
        month: string,
    }): CancelablePromise<BasicResponseListString> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/binder-app/ai-insight/report/{keyword-id}/available-dates',
            path: {
                'keyword-id': keywordId,
            },
            query: {
                'month': month,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * AI 인사이트 리포트(v2) 조회
     * 400 코드값을 반환받는 케이스
     * * 리포트를 생성하기 위해 필요한 분석컨텐츠는 존재하지만, 리포트가 아직 생성되지 않은 경우
     * ```
     * {
         * "success": false,
         * "code": "400",
         * "message": "리포트가 생성되지 않았습니다.",
         * "data": null
         * }
         * ```
         * 404 코드값을 반환받는 케이스
         * * 리포트를 생성하기 위해 필요한 분석컨텐츠가 존재하지 않는 경우
         * ```
         * {
             * "success": false,
             * "code": "404",
             * "message": "리포트가 생성되지 않았습니다.",
             * "data": null
             * }
             * ```
             * 코드값은 Http status 를 의미하지 않습니다.
             * Http status 는 400 고정입니다.
             *
             * @returns BasicResponseAiInsightReport OK
             * @throws ApiError
             */
            public static getReportOfVersion2({
                keywordId,
                date,
            }: {
                /**
                 * 키워드 ID
                 */
                keywordId: string,
                /**
                 * 시작일
                 */
                date: string,
            }): CancelablePromise<BasicResponseAiInsightReport> {
                return __request(OpenAPI, {
                    method: 'GET',
                    url: '/binder-app/ai-insight/report/v2/{keyword-id}',
                    path: {
                        'keyword-id': keywordId,
                    },
                    query: {
                        'date': date,
                    },
                    errors: {
                        400: `Bad Request`,
                        403: `Forbidden`,
                        404: `Not Found`,
                        409: `Conflict`,
                        500: `Internal Server Error`,
                    },
                });
            }

            /**
             * AI 인사이트 리포트 출처 목록 조회 (페이지네이션)
             * @returns BasicResponseContentLinkCollection OK
             * @throws ApiError
             */
            public static getReportContentLinks({
                keywordId,
                date,
                page,
                pageSize,
            }: {
                /**
                 * 키워드 ID
                 */
                keywordId: string,
                /**
                 * 날짜
                 */
                date: string,
                /**
                 * 페이지 번호 (1부터 시작)
                 */
                page?: number,
                /**
                 * 페이지 사이즈 (1 ~ 100)
                 */
                pageSize?: number,
            }): CancelablePromise<BasicResponseContentLinkCollection> {
                return __request(OpenAPI, {
                    method: 'GET',
                    url: '/binder-app/ai-insight/report/v2/{keyword-id}/links',
                    path: {
                        'keyword-id': keywordId,
                    },
                    query: {
                        'date': date,
                        'page': page,
                        'pageSize': pageSize,
                    },
                    errors: {
                        400: `Bad Request`,
                        403: `Forbidden`,
                        404: `Not Found`,
                        409: `Conflict`,
                        500: `Internal Server Error`,
                    },
                });
            }

        }
